import { Box, Button, Divider, Flex, Group, Image, SimpleGrid, Space, Text, Title, Tooltip } from '@mantine/core';
import React, { memo, useContext, useEffect, useState } from 'react';
// import mainettilogo from '../../assets/image/mainettilogoimg.png';
import { FaRegArrowAltCircleDown, FaRegEdit } from 'react-icons/fa';
// import { authContext } from '../../context/AuthProvider.component';
import { baseUrl } from '../../Constants/constant';
import classes from './LcaReport.module.css';
// import useFetch from '../../Customhooks/useFetch';
import LcaTableComponent from '../ComputeLca/NewLCA/CategoryComponent/LCAReport/LcaTable/LcaTable.component';
import DataPieChart from '../ComputeLca/NewLCA/CategoryComponent/LCAReport/PieChart/PieChart.component';
import { useDisclosure } from '@mantine/hooks';
import ReportPdf from '../../CustomComponent/DownloadPdfReport/ReportPdf.component';
import { authContext } from '../../context/AuthProvider.component';
import { useNavigate } from 'react-router-dom';

interface LcaReportProps {
  value: any;
  reportId: string;
}

interface CustomerData {
  icon_name: string;
  // Add other properties as needed
}

interface LcaData {
  product_name: string;
  product_description: string;
  value: string;
  Customer: CustomerData;
  id: any;
  DatabaseVersion: any;
  ComputeCommentLogo: any;
  product_image: any;
  report_name: string;
  // Add other properties as needed
}

const LcaReport: React.FC<LcaReportProps> = ({ value, reportId }) => {
  const navigate = useNavigate(); // Fixed: Added missing navigate declaration
  const updatedUrl = baseUrl.replace("/api/", "");
  // const token = localStorage.getItem("token");
  // const [imageUrl, setImageUrl] = useState<string[]>([]);
  // const [imageClasses, setImageClasses] = useState<string[]>([]);
  const [selectedId, setSelectedId] = useState<any>();
  const [confirmPdfOpened, { open: openConfirmPdf, close: closeConfirmPdf }] = useDisclosure(false);
  const { setComputeId, setDraftLca } = useContext<any>(authContext);

  const data: LcaData | undefined = value;

  const handleDownloadPDF = (id: any) => {
    openConfirmPdf();
    setSelectedId(id)
  };
  const handleEdit = (id: number) => {
    setComputeId(id)
    setDraftLca(0)
    navigate('/newlca/sub-category')
  };

  return (
    <>
      {data ? (<>
        <Space h="lg" />
        <Flex
          gap="md"
          justify="space-between"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Title order={4}>Report</Title>
          <Group>
            <Box onClick={() => handleEdit(data?.id)}><FaRegEdit size={26} cursor={'pointer'} /></Box>
            <Tooltip label="Download Lca Report" color="#404040">
              <Button
                variant="filled"
                onClick={() => handleDownloadPDF(data?.id)}
                size='sm'
                styles={{
                  root: {
                    backgroundColor: '#404040',
                    '&:hover': {
                      backgroundColor: '#505050'
                    }
                  }
                }}
              >
                <FaRegArrowAltCircleDown size={25} />
              </Button>
            </Tooltip>
          </Group>
        </Flex>
        <Space h="lg" />
        <Divider />
        <Box id={reportId}>
          <Box className={classes.report_container}>
            <Box className={classes.report_header}>
              <div className={classes.report_left_header}>

                <Text size='xl' fw={700}>PRODUCT LIFECYCLE ASSESSMENT</Text>
                <Space h="xs" />
                <Box pl={20}>
                  <Title order={4} tt="uppercase">REPORT NAME: {data.report_name}</Title>
                  <Title order={4} tt="uppercase">PRODUCT NAME: {data.product_name}</Title>
                  <Title order={4} tt="uppercase">DATABASE VERSION: {data?.DatabaseVersion?.db_version}</Title>
                  <Box w={350} mt={24}>
                    <Text size="xl" lh={1} component="div"
                      style={{
                        wordBreak: 'break-all',
                        whiteSpace: 'normal',
                      }}
                    >
                      <Title
                        order={4}
                        style={{ display: 'inline', textTransform: 'uppercase', marginRight: 4 }}
                      >
                        DESCRIPTION :
                      </Title>{data.product_description}
                    </Text>
                  </Box>
                </Box>
              </div>
            </Box>
            <Box>
              <Box style={{ width: '50%' }}>
                <Box>
                  {data.ComputeCommentLogo?.ComputeCustomerLogo?.icon_name?.length > 0 && <Image
                    fit="contain"
                    src={`${updatedUrl}${data.ComputeCommentLogo?.ComputeCustomerLogo?.icon_name}`}
                    alt={`Customer logo`}
                    // onLoad={(e) => handleImageLoad(e, index)}
                    style={{ width: '100px' }}
                  />}
                  {data?.product_image?.length > 0 && <Image
                    fit="contain"
                    src={`${updatedUrl}${data?.product_image}`}
                    alt={`Customer logo`}
                    // onLoad={(e) => handleImageLoad(e, index)}
                    style={{ width: '100px' }}
                  />}
                </Box>
              </Box>
            </Box>
          </Box>
          <SimpleGrid
            cols={{ base: 1, sm: 1, lg: 2 }}
          >
            <Box style={{ width: '100%' }}><LcaTableComponent data={data} /></Box>
            <Box style={{ width: '100%' }}><DataPieChart data={data} /></Box>
          </SimpleGrid>
        </Box>
      </>
      ) : (
        <Box py="xl" ta="center">
          <Text>Loading report data...</Text>
        </Box>
      )}
      <ReportPdf
        isConfirmOpen={confirmPdfOpened}
        closeConfirm={closeConfirmPdf}
        id={selectedId}
      />
    </>
  );
};

export default memo(LcaReport);